import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { onboardingApi } from '../../../api/recruiting.js';

const STATUSES = ['pending', 'in_progress', 'done', 'skipped'];

export default function JourneyDetail() {
  const { id } = useParams();
  const [journey, setJourney] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(() => {
    setLoading(true);
    onboardingApi
      .getJourney(id)
      .then((d) => setJourney(d?.journey || null))
      .catch((e) => setError(e.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }, [id]);
  useEffect(refresh, [refresh]);

  async function setStatus(taskId, status) {
    try {
      await onboardingApi.updateTask(taskId, { status });
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update task');
    }
  }

  if (loading && !journey) return <div className="muted" data-testid="onboarding-journey-detail-page" data-loading="true">Loading…</div>;
  if (!journey) return <div className="alert error">Journey not found</div>;

  return (
    <section data-testid="onboarding-journey-detail-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div>
          <h1>Onboarding · {journey.employee_name || journey.employee_code}</h1>
          <p className="muted">{journey.template_name || 'Custom'} · <span className={`chip status-${journey.status}`} data-testid="onboarding-journey-status">{journey.status}</span></p>
        </div>
      </header>
      {error && <div className="alert error">{error}</div>}

      <div className="card">
        <table className="data-table" data-testid="onboarding-task-list">
          <thead><tr><th>Task</th><th>Owner</th><th>Due</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {(journey.tasks || []).map((t) => (
              <tr key={t.id} data-testid={`onboarding-task-${t.id}`}>
                <td>{t.title}</td>
                <td>{t.owner_name || '—'}</td>
                <td>{t.due_date ? String(t.due_date).slice(0, 10) : '—'}</td>
                <td>
                  <select
                    value={t.status}
                    data-testid={`onboarding-task-${t.id}-status`}
                    onChange={(e) => setStatus(t.id, e.target.value)}
                  >
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td>
                  {t.status !== 'done' && (
                    <button className="btn ghost" data-testid={`onboarding-task-${t.id}-done`} onClick={() => setStatus(t.id, 'done')}>
                      Mark done
                    </button>
                  )}
                </td>
              </tr>
            ))}
            {(journey.tasks || []).length === 0 && <tr><td colSpan={5} className="muted">No tasks.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
